import React from "react"
import LayoutProvider from 'providers/Layout/Layout.provider';
import DashPageWrapper from './DashPageWrapper.component';

const DashPageWrapperProvider: React.FC<{ children: React.ReactNode }>= (props) =>(
    <LayoutProvider>
      <DashPageWrapper {...props} />
    </LayoutProvider>
  );

export default DashPageWrapperProvider;